<script>
  import { hooksStore } from "../../stores/hooks.store";
  import { userStore } from "../../stores/user.store";

  import {
    getMap,
    vygenerujIdZdroja,
    sourceExists,
    pridajVrstvy,
    nastavViditelnostVrstvy,
    zobrazDataNaMape,
    pointTo,
    odstranVrstvuZMapy,
  } from "../../helpers/map";
  import {
    vratVrstvyMapyPodlaTypu,
    vratKodIkonkyPodlaTypu,
    vratKodFarbyPodlaTypu,
  } from "../../helpers/config";
  import { vratDataZDvojkliku } from "../../api/click";
  import { vratDataZPrieniku } from "../../api/intersect";
  import { ziskajDataIkonky } from "../../components/Icon/functions";
  import { vratGeojsonData } from "../../api/geojson";
  import { Base64 } from "js-base64";

  import get from "get-value";
  import center from "@turf/center";

  hooksStore.addAction("dblclick", "Popup.svelte", dblclick);
  hooksStore.addAction("zobrazPopUpOkno", "Popup.svelte", zobrazPopUpOkno);
  hooksStore.addFilter(
    "vygenerujObsahPopup",
    "Popup.svelte",
    vygenerujObsahPopup
  );
  hooksStore.addAction(
    "zobrazPopUpOknoPodlaSourceId",
    "Popup.svelte",
    zobrazPopUpOknoPodlaSourceId
  );
  hooksStore.addAction(
    "zmazatVsetkyPopupOkna",
    "Popup.svelte",
    zmazatVsetkyPopupOkna
  );

  function zmazatVsetkyPopupOkna() {
    const popup = document.getElementsByClassName("maplibregl-popup");
    if (popup.length) {
      popup[0].remove();
    }
  }

  /**
   * Sprcovanie dvojkliku na mapu
   * @param {object}    e   Event
   */
  async function dblclick(e) {
    const { lat, lng } = e.lngLat;
    const map = getMap();
    const typ = "dblclick";
    const source_id = vygenerujIdZdroja(typ, `${lat}_${lng}`);
    if (!source_id) {
      return false;
    }

    // ak uz taky zdroj mam, tak ho nemozem znova pridava
    // ale mozem ho znova nacentrovat
    if (sourceExists(map, source_id) !== false) {
      return false;
    }

    // z konfigu si vytiahnem data o vrstve daneho typu
    // tych vrstiev moze byt viac. Napr lokalita ma oramovanie a vyfarbenie
    const vrstvy = vratVrstvyMapyPodlaTypu("point");
    if (vrstvy) {
      const response = await vratDataZDvojkliku(lat, lng);
      const data = get(response, "data", false);
      if (data) {
        const obsah = await vygenerujObsahPopup(data, source_id);

        const sourceData = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: {
                description: obsah,
              },
              geometry: {
                type: "Point",
                coordinates: [lng, lat],
              },
            },
          ],
        };

        // vytvorim si zdroj dat
        map.addSource(source_id, {
          type: "geojson",
          data: sourceData,
          generateId: true,
        });

        pridajVrstvy(typ, `${lat}_${lng}`, true);
        zobrazPopUpOkno([lng, lat], obsah, sourceData, source_id);
      }
    }
  }

  /**
   * Vygenerovanie obsahu popup okna
   * @param {float} lat
   * @param {float} lng
   * @param {string}    source_id
   */
  function vygenerujObsahPopup(data, source_id) {
    let obsah = "";
    if (data) {
      obsah = `<div class="tab-data active"><ul class="popup-list">`;
      for (const item of data) {
        if (item.id || item.layer) {
          const layer = get(item, "layer")
            ? // ? btoa(JSON.stringify(item.layer))
              Base64.encode(JSON.stringify(item.layer))
            : false;
          obsah += `<li data-typ="${item.typ}" data-id="${
            item.id || ""
          }" data-layer="${layer || ""}">`;
          const kod_ikonky = vratKodIkonkyPodlaTypu(item.typ);
          if (kod_ikonky) {
            let ikonkaData = ziskajDataIkonky(kod_ikonky);
            if (typeof ikonkaData === "object" && ikonkaData !== null) {
              const attrs = get(ikonkaData, "attrs.svg", false);
              const ikonka = get(ikonkaData, "ikonka.body", false);
              let html_attrs = "";
              if (attrs !== undefined) {
                for (const attr in attrs) {
                  if (attr === "class") {
                    attrs[attr] += ` color__text--${vratKodFarbyPodlaTypu(
                      item.typ
                    )}`;
                  }
                  html_attrs += `${attr}="${attrs[attr]}"`;
                }
              }
              if (ikonka !== undefined) {
                obsah += `
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" ${html_attrs}>
                      ${ikonka}
                    </svg>
                  </span>
                `;
              }
            }
          }
          obsah += `
              <span class="color__text--${vratKodFarbyPodlaTypu(item.typ)}">${
            item.title
          }`;
          if (item.label !== undefined) {
            obsah += ` <small>${item.label}</small>`;
          }
          obsah += `</span>`;
          obsah += `
            </li>
          `;
        }
      }
      obsah += `</ul></div></div><div class="tab-poznamka"></div>`;
      obsah += `<div class="footer-buttons">
                  <div class="let">
                    <span class="pridat-poznamku active" data-source-id="${source_id}">Pridať poznámku</span>`;
      obsah += hooksStore.applyFilters("popupFooterButtons", "", source_id);
      obsah += `    <span class="zobrazit-poznamku">Zobraziť poznámku</span>
                    <span class="zobrazit-data" data-poznamka-layer="">Zobraziť prieniky</span>
                  </div>
                  <div class="right">
                    <span class="upravit-poznamku" data-source-id="${source_id}" data-poznamka-id="">Upraviť</span>
                    <span class="zmazat-poznamku" data-source-id="${source_id}" data-poznamka-id="">Zmazať</span>
                    <span data-source-id="${source_id}" class="zavriet-okno active">Zavrieť</span>
                  </div>
                </div>`;
    }

    return obsah;
  }

  /**
   * Zobrazenie popup okna
   * @param {array} coordinates
   * @param {text} description
   */
  async function zobrazPopUpOkno(
    coordinates,
    description,
    sourceData,
    source_id_parent
  ) {
    const map = getMap();
    // musi tu byt timeout kvoli konfliktu eventu draw.create
    // https://github.com/mapbox/mapbox-gl-draw/issues/779
    setTimeout(() => {
      // zavriem vsetky popup okna, ked idem otvorit nove
      const popups = document.getElementsByClassName("maplibregl-popup");
      if (popups.length) {
        popups[0].remove();
      }
      const popup = new maplibregl.Popup({
        maxWidth: "300px",
        offset: {
          top: [0, 10],
          bottom: [0, -10],
          right: [0, 0],
          left: [0, 0],
          "top-left": [0, 10],
          "top-right": [0, 10],
          "bottom-left": [0, -40],
          "bottom-right": [0, -40],
        },
      })
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(map);
      popup.sourceData = sourceData;
      popup.source_id_parent = source_id_parent;

      ovladacieEventy(popup);
      listEventy(popup);
    }, 0);
  }

  /**
   * Hover na jednotlive mapove polozky v popup okne
   * @param {object}    popup
   */
  function listEventy(popup, isElement = false) {
    const popupElem = isElement ? popup : popup.getElement();
    const listItems = popupElem.querySelectorAll(
      ".maplibregl-popup-content ul li"
    );
    const user = userStore.getUser();
    for (const item of listItems) {
      const id = item.getAttribute("data-id");
      const typ = item.getAttribute("data-typ");
      const gistyp = item.getAttribute("data-gistyp") || typ;
      const layer = item.getAttribute("data-layer");
      const nazov = item
        .querySelector("span:last-child")
        .innerHTML.replace(/ *\<small>(.*)<\/small>/g, "");
      if (!gistyp && (!id || !layer)) {
        return false;
      }

      if (id) {
        // vytvorim si ID pre zdroj mapboxu. Musi to byt jedinecne
        const source_id = vygenerujIdZdroja(gistyp, id);
        if (!source_id) {
          return false;
        }

        let timeout = null;

        const mouseover_f = function (event) {
          if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
          }
          let stav = get(user, "options.mapa.stav", false) || {};
          if (get(stav[source_id]) === undefined) {
            event.preventDefault();
            event.stopPropagation();

            timeout = setTimeout(() => {
              if (sourceExists(source_id) !== false) {
                nastavViditelnostVrstvy(gistyp, source_id, "visible");
              } else {
                // ak taky zdroj nemam, musim ho najprv vytvoritt
                zobrazDataNaMape(
                  { id: id, typ: gistyp, hover: true, nazov: nazov },
                  false
                );
              }
            }, 300);
          }
        };
        const mouseout_f = function (event) {
          if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
          }

          let stav = get(user, "options.mapa.stav", false) || {};
          if (get(stav[source_id]) === undefined) {
            event.preventDefault();
            event.stopPropagation();

            // timeout = setTimeout(() => {
            if (sourceExists(source_id) !== false) {
              nastavViditelnostVrstvy(gistyp, source_id, "none");
            }
            // }, 300);
          }
        };

        item.addEventListener("mouseover", mouseover_f);
        item.addEventListener("mouseout", mouseout_f);

        item.addEventListener("click", async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
          }

          item.removeEventListener("mouseover", mouseover_f);
          item.removeEventListener("mouseout", mouseout_f);

          if (sourceExists(source_id) !== false) {
            const vrstvy = vratVrstvyMapyPodlaTypu(gistyp);
            // z api vratim geojson data
            const sourceData = await vratGeojsonData(gistyp, id);
            if (!sourceData) {
              return false;
            }

            nastavViditelnostVrstvy(gistyp, source_id, "visible");
            hooksStore.doAction(
              "ulozVrstvyDoStavu",
              { id: id, gistyp: gistyp, nazov: nazov },
              source_id,
              sourceData,
              vrstvy[0].typ_vrstvy
            );
            pointTo(sourceData, vrstvy[0].typ_vrstvy);
          } else {
            // ak taky zdroj nemam, musim ho najprv vytvoritt
            zobrazDataNaMape({ id: id, typ: gistyp, nazov: nazov });
          }
          hooksStore.doAction(
            "nacitajDatagrid",
            hooksStore.applyFilters("resetniANastavFilter", {
              id: id,
              type: gistyp,
              tab: typ || "default",
            })
          );
          popup.remove();
        });
      } else if (layer) {
        item.addEventListener("click", async (event) => {
          event.preventDefault();
          event.stopPropagation();
          hooksStore.doAction("drawDeselect");
          hooksStore.doAction(
            "nacitajDatagrid",
            hooksStore.applyFilters("resetniANastavFilter", {
              layer: layer,
              type: gistyp,
              tab: typ || "default",
            })
          );
          popup.remove();
        });
      }
    }

    const linkItems = popupElem.querySelectorAll("span.link");
    for (const item of linkItems) {
      item.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const id = item.getAttribute("data-id");
        const gistyp = item.getAttribute("data-gistyp");
        const typ = item.getAttribute("data-typ");

        if (!gistyp || !id) {
          return false;
        }

        hooksStore.doAction(
          "nacitajDatagrid",
          hooksStore.applyFilters("resetniANastavFilter", {
            id: id,
            type: gistyp,
            tab: typ || "default",
          })
        );

        popup.remove();
      });
    }
  }

  /**
   * Eventy v paticke popup okna
   * @param {object}    popup
   */
  async function ovladacieEventy(popup) {
    const map = getMap();
    const popupElem = popup.getElement();

    /**
     * ZAVRIET OKNO
     */
    const zavrietOkno = popupElem.querySelector(
      ".footer-buttons .zavriet-okno"
    );
    if (zavrietOkno) {
      const sourceId = zavrietOkno.getAttribute("data-source-id");
      zavrietOkno.addEventListener("click", (e) => {
        e.preventDefault();
        if (map.getLayer(`${sourceId}_0`)) {
          map.removeLayer(`${sourceId}_0`);
        }

        if (map.getSource(sourceId)) {
          map.removeSource(sourceId);
        }
        popup.remove();
      });
    }

    /**
     * PRIDAT POZNAMKU
     */
    const pridatPoznamku = popupElem.querySelector(
      ".footer-buttons .pridat-poznamku"
    );

    if (pridatPoznamku) {
      pridatPoznamku.addEventListener("click", (e) => {
        e.preventDefault();

        const source_id_edit = pridatPoznamku.getAttribute("data-source-id");
        const geojson = JSON.stringify(popup.sourceData);

        hooksStore.doAction("zobrazFormularNaPoznamku", {
          geojson,
          popup,
          sourceId: source_id_edit,
        });

        layerNaKreslenie(source_id_edit, null);
      });
    }

    /**
     * ZOBRAZIT POZNAMKU
     */
    const zobrazitPoznamku = popupElem.querySelector(
      ".footer-buttons .zobrazit-poznamku"
    );
    if (zobrazitPoznamku) {
      zobrazitPoznamku.addEventListener("click", (e) => {
        e.preventDefault();

        const content = zobrazitPoznamku.closest(".maplibregl-popup-content");
        content.querySelector(".tab-data").classList.remove("active");
        content.querySelector(".tab-poznamka").classList.add("active");

        const footer = zobrazitPoznamku.closest(".footer-buttons");
        footer.querySelector(".zobrazit-data").classList.add("active");
        footer.querySelector(".upravit-poznamku").classList.add("active");
        footer.querySelector(".zmazat-poznamku").classList.add("active");

        zobrazitPoznamku.classList.remove("active");
      });
    }

    /**
     * ZOBRAZIT DATA
     */
    const zobrazitData = popupElem.querySelector(
      ".footer-buttons .zobrazit-data"
    );
    if (zobrazitData) {
      zobrazitData.addEventListener("click", async (e) => {
        e.preventDefault();
        let obsah = "";
        const content = zobrazitData.closest(".maplibregl-popup-content");
        let layer = e.target.getAttribute("data-poznamka-layer");
        if (layer) {
          layer = JSON.parse(Base64.decode(layer));

          if (content.querySelector(".tab-data").innerHTML === "") {
            const response = await vratDataZPrieniku({
              layer: layer.features[0].geometry,
              radius: false,
            });
            const data = get(response, "data", false);
            if (data) {
              data.map((item) => {
                item.layer = layer.features[0].geometry;
              });
              obsah = `<ul class="popup-list">`;
              for (const item of data) {
                if (item.id || item.layer) {
                  const layer = get(item, "layer")
                    ? // ? btoa(JSON.stringify(item.layer))
                      Base64.encode(JSON.stringify(item.layer))
                    : false;
                  obsah += `<li data-typ="${item.typ}" data-id="${
                    item.id || ""
                  }" data-layer="${layer || ""}">`;
                  const kod_ikonky = vratKodIkonkyPodlaTypu(item.typ);
                  if (kod_ikonky) {
                    let ikonkaData = ziskajDataIkonky(kod_ikonky);
                    if (typeof ikonkaData === "object" && ikonkaData !== null) {
                      const attrs = get(ikonkaData, "attrs.svg", false);
                      const ikonka = get(ikonkaData, "ikonka.body", false);
                      let html_attrs = "";
                      if (attrs !== undefined) {
                        for (const attr in attrs) {
                          if (attr === "class") {
                            attrs[
                              attr
                            ] += ` color__text--${vratKodFarbyPodlaTypu(
                              item.typ
                            )}`;
                          }
                          html_attrs += `${attr}="${attrs[attr]}"`;
                        }
                      }
                      if (ikonka !== undefined) {
                        obsah += `
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" ${html_attrs}>
                              ${ikonka}
                            </svg>
                          </span>
                        `;
                      }
                    }
                  }
                  obsah += `
                      <span class="color__text--${vratKodFarbyPodlaTypu(
                        item.typ
                      )}">${item.title}`;
                  if (item.label !== undefined) {
                    obsah += ` <small>${item.label}</small>`;
                  }
                  obsah += `</span>`;
                  obsah += `
                    </li>
                  `;
                }
              }
              obsah += `</ul>`;
            }
            content.querySelector(".tab-data").innerHTML = obsah;
            listEventy(zobrazitData.closest(".maplibregl-popup"), true);
          }
        }

        content.querySelector(".tab-data").classList.add("active");
        content.querySelector(".tab-poznamka").classList.remove("active");

        const footer = zobrazitData.closest(".footer-buttons");
        footer.querySelector(".zobrazit-data").classList.remove("active");
        footer.querySelector(".upravit-poznamku")
          ? footer.querySelector(".upravit-poznamku").classList.remove("active")
          : null;
        footer.querySelector(".zmazat-poznamku")
          ? footer.querySelector(".zmazat-poznamku").classList.remove("active")
          : null;
        footer.querySelector(".zobrazit-poznamku")
          ? footer.querySelector(".zobrazit-poznamku").classList.add("active")
          : null;

        zobrazitData.classList.remove("active");
      });
    }

    /**
     * ZMAZAT POZNAMKU
     */
    const zmazat = popupElem.querySelector(".footer-buttons .zmazat-poznamku");
    if (zmazat) {
      zmazat.addEventListener("click", (e) => {
        e.preventDefault();

        const source_id_zmazat = zmazat.getAttribute("data-source-id");
        const poznamka_id = zmazat.getAttribute("data-poznamka-id");

        hooksStore.doAction("confirmDialog", {
          texts: {
            title: "Určite chcete zmazať túto poznámku?",
            text: "Táto akcia sa nedá vrátiť.",
            confirm: "Áno",
            cancel: "Zrušiť",
          },
          callback: () => {
            hooksStore.doAction(
              "zmazatPoznamku",
              source_id_zmazat,
              poznamka_id,
              popup
            );
          },
        });
      });
    }

    /**
     * UPRAVIT POZNAMKU
     */
    const upravit = popupElem.querySelector(
      ".footer-buttons .upravit-poznamku"
    );
    if (upravit) {
      upravit.addEventListener("click", (e) => {
        const map = getMap();
        e.preventDefault();

        const source_id_edit = upravit.getAttribute("data-source-id");
        const poznamka_id = upravit.getAttribute("data-poznamka-id");

        const geojson = JSON.stringify(
          map.getStyle().sources[source_id_edit].data
        );

        const props =
          map.getStyle().sources[source_id_edit].data.features[0].properties;

        hooksStore.doAction("zobrazFormularNaPoznamku", {
          geojson,
          popup,
          poznamka_id,
          title: props.title,
          public: props.public,
          note_desc: props.note_desc,
          color: props.color,
          sourceId: source_id_edit,
        });

        layerNaKreslenie(source_id_edit, poznamka_id);
      });
    }

    hooksStore.doAction("popupOvladacieEventy", popupElem, popup);
  }

  function layerNaKreslenie(source_id_edit, poznamka_id) {
    const map = getMap();
    const popup = document.getElementsByClassName("maplibregl-popup");
    if (popup.length) {
      popup[0].remove();
    }

    if (poznamka_id) {
      const sourceData = map.getStyle().sources[source_id_edit].data;
      // odstranVrstvuZMapy(source_id_edit);
      for (let i = 0; i < sourceData.features.length; i++) {
        const typ = sourceData.features[i].geometry.type.toLowerCase();
        nastavViditelnostVrstvy(typ, source_id_edit, "none", i);
      }
      hooksStore.doAction("editSourceDraw", sourceData, poznamka_id);
    }
  }

  function zobrazPopUpOknoPodlaSourceId(source_id, data) {
    if (!source_id) {
      return false;
    }

    const gistyp = data[0];
    const id = data[1];
    const typ = data[2];
    const nazov = data[3];

    const map = getMap();
    if (sourceExists(source_id) !== false) {
      const source = map.getSource(source_id);
      const point = center(source._data);
      zobrazPopUpOkno(
        point.geometry.coordinates,
        `<span class="link color__text--${vratKodFarbyPodlaTypu(
          typ
        )}" data-typ="${typ}" data-gistyp="${gistyp}" data-id="${
          source._data.features[0].properties.id || ""
        }">${nazov || source._data.features[0].properties.nazov}</span>`,
        source._data
      );
    }
  }
</script>
